import Announcement from './Announcement'

export default Announcement
// eslint-disable-next-line import/export
export * from './Announcement'
